import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, createBlock as _createBlock, vShow as _vShow } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "page-wrap ep"
}
const _hoisted_2 = {
  key: 0,
  class: "ep-preview"
}
const _hoisted_3 = { class: "ep-layout" }
const _hoisted_4 = { class: "ep-main" }
const _hoisted_5 = { class: "ep-fmt-where" }
const _hoisted_6 = { class: "ep-paper" }
const _hoisted_7 = { class: "ve-lane-wrap" }
const _hoisted_8 = { class: "ve-lane rs-lane" }
const _hoisted_9 = ["id", "aria-pressed", "onClick"]
const _hoisted_10 = { class: "rs-seat-i" }
const _hoisted_11 = { class: "rs-seat-n" }
const _hoisted_12 = {
  key: 0,
  class: "rs-ed"
}
const _hoisted_13 = { class: "rs-ed-h" }
const _hoisted_14 = { class: "rs-seat-i big" }
const _hoisted_15 = { class: "rs-who-fields" }
const _hoisted_16 = { class: "rs-ed-tools" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = ["disabled"]
const _hoisted_19 = { class: "rs-note" }
const _hoisted_20 = { class: "rs-sec rs-acc" }
const _hoisted_21 = { class: "rs-sec-h" }
const _hoisted_22 = { class: "rs-sec-l static" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { class: "rs-acc-n" }
const _hoisted_25 = ["onUpdate:modelValue"]
const _hoisted_26 = ["onUpdate:modelValue"]
const _hoisted_27 = { class: "rs-ed-tools" }
const _hoisted_28 = ["disabled", "onClick"]
const _hoisted_29 = ["disabled", "onClick"]
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { class: "rs-sec-h" }
const _hoisted_32 = ["onUpdate:modelValue"]
const _hoisted_33 = { class: "rs-ed-tools" }
const _hoisted_34 = ["disabled", "onClick"]
const _hoisted_35 = ["disabled", "onClick"]
const _hoisted_36 = ["onClick"]
const _hoisted_37 = {
  key: 0,
  class: "rs-sec-hint"
}
const _hoisted_38 = { class: "rs-body" }
const _hoisted_39 = {
  key: 1,
  class: "ep-empty"
}
const _hoisted_40 = ["onClick"]
const _hoisted_41 = {
  key: 0,
  class: "error-msg-wrap"
}
const _hoisted_42 = { class: "error-msg ep-save rs-paste" }
const _hoisted_43 = { class: "rs-paste-sum" }
const _hoisted_44 = { class: "ep-save-btns" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_editor_bar = _resolveComponent("editor-bar")!
  const _component_editor_mode_toggle = _resolveComponent("editor-mode-toggle")!
  const _component_playbook_view = _resolveComponent("playbook-view")!
  const _component_tip_tap_toolbar = _resolveComponent("tip-tap-toolbar")!
  const _component_editor_doc_head = _resolveComponent("editor-doc-head")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_tip_tap = _resolveComponent("tip-tap")!
  const _component_editor_activity = _resolveComponent("editor-activity")!
  const _component_confirm_delete = _resolveComponent("confirm-delete")!
  const _component_editor_details_drawer = _resolveComponent("editor-details-drawer")!
  const _component_editor_save_dialog = _resolveComponent("editor-save-dialog")!
  const _component_editor_discard_dialog = _resolveComponent("editor-discard-dialog")!
  const _component_ai_improve_panel = _resolveComponent("ai-improve-panel")!

  return (_ctx.isLoaded)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_editor_bar, {
          name: _ctx.node.Name,
          version: _ctx.node.Version,
          dirty: _ctx.dirty,
          "type-label": "role sheet",
          onCancel: _cache[1] || (_cache[1] = ($event: any) => (_ctx.cancel())),
          onSave: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openSave())),
          onHeight: _cache[3] || (_cache[3] = ($event: any) => (_ctx.barHeight = $event))
        }, {
          default: _withCtx(() => [
            _createElementVNode("button", {
              type: "button",
              class: "ai-btn pb-btn",
              title: "Improve with AI",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showAIModal = true))
            }, [...(_cache[38] || (_cache[38] = [
              _createElementVNode("svg", {
                viewBox: "0 0 24 24",
                class: "ep-fill"
              }, [
                _createElementVNode("path", { d: "M13 0L3.5 14H10l-1.5 10L20 9h-6.5L15 0h-2z" })
              ], -1),
              _createElementVNode("span", null, "Improve with AI", -1)
            ]))])
          ]),
          _: 1
        }, 8, ["name", "version", "dirty"]),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.$store.state.routeLoaded ? 'slide-up view' : 'hide')
        }, [
          _createVNode(_component_editor_mode_toggle, {
            preview: _ctx.showPreview,
            "changed-count": _ctx.changedSeats.length,
            "changed-label": "seats",
            onEdit: _cache[4] || (_cache[4] = ($event: any) => (_ctx.closePreview())),
            onPreview: _cache[5] || (_cache[5] = ($event: any) => (_ctx.openPreview()))
          }, null, 8, ["preview", "changed-count"]),
          (_ctx.showPreview)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_playbook_view, {
                  "preview-node": _ctx.previewNode,
                  "hide-bar": true
                }, null, 8, ["preview-node"])
              ]))
            : _createCommentVNode("", true),
          _withDirectives(_createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", {
                class: _normalizeClass(["ep-fmt", { live: _ctx.activeEditor }]),
                style: _normalizeStyle({ top: _ctx.barHeight + 'px' })
              }, [
                _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.activeEditor && _ctx.activeSection ? (_ctx.seatLabel(_ctx.current) || 'Seat') + ' · ' + (_ctx.activeSection.label || 'Section') : 'Click into a section to format it'), 1),
                (_ctx.activeEditor)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "ep-fmt-btns",
                      onMousedown: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.keepEditorFocus && _ctx.keepEditorFocus(...args)))
                    }, [
                      _createVNode(_component_tip_tap_toolbar, {
                        editor: _ctx.activeEditor,
                        "hide-h3": true,
                        "hide-h4": true,
                        "hide-table": true,
                        "show-align": true
                      }, null, 8, ["editor"])
                    ], 32))
                  : _createCommentVNode("", true)
              ], 6),
              _createElementVNode("article", _hoisted_6, [
                _createVNode(_component_editor_doc_head, {
                  locs: _ctx.locs,
                  deps: _ctx.deps,
                  types: _ctx.types,
                  "owner-names": _ctx.ownerNames,
                  version: _ctx.node.Version,
                  onOpen: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showDetails = true))
                }, null, 8, ["locs", "deps", "types", "owner-names", "version"]),
                _cache[56] || (_cache[56] = _createElementVNode("div", { class: "ve-help" }, [
                  _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
                    _createElementVNode("path", { d: "M8 13V4.5a1.5 1.5 0 0 1 3 0V12M11 11.5v-2a1.5 1.5 0 0 1 3 0V12M14 10.5a1.5 1.5 0 0 1 3 0V12M17 11.5a1.5 1.5 0 0 1 3 0V16a6 6 0 0 1-6 6h-2 .21a6 6 0 0 1-5-2.69L7 19c-.31-.48-1.4-2.38-3.26-5.7a1.5 1.5 0 0 1 .54-2.02 1.87 1.87 0 0 1 2.28.28L8 13" })
                  ]),
                  _createTextVNode(" Pick a seat to edit it. Drag seats to reorder them. Each seat is one role on the sheet. ")
                ], -1)),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_draggable, {
                      list: _ctx.sheet.seats,
                      class: "rs-lane-seats",
                      onStart: _ctx.dragStart,
                      onEnd: _ctx.dragEnd,
                      animation: 150,
                      "ghost-class": "kanban-ghost",
                      "force-auto-scroll-fallback": true,
                      delay: 200,
                      "delay-on-touch-only": true,
                      "touch-start-threshold": 5
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.seats, (seat, i) => {
                          return (_openBlock(), _createElementBlock("button", {
                            key: seat.id,
                            type: "button",
                            id: 'rs-seat-' + i,
                            class: _normalizeClass(['rs-seat', { on: _ctx.selected == i }]),
                            "aria-pressed": _ctx.selected == i,
                            onClick: ($event: any) => (_ctx.select(i))
                          }, [
                            _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.initials(seat)), 1),
                            _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.seatLabel(seat) || 'New seat'), 1)
                          ], 10, _hoisted_9))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["list", "onStart", "onEnd"]),
                    _createElementVNode("button", {
                      type: "button",
                      class: "ve-add rs-add",
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.addSeat()))
                    }, [...(_cache[39] || (_cache[39] = [
                      _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
                        _createElementVNode("path", { d: "M12 5v14M5 12h14" })
                      ], -1),
                      _createElementVNode("span", null, "Add seat", -1)
                    ]))])
                  ])
                ]),
                (_ctx.current)
                  ? (_openBlock(), _createElementBlock("section", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.initials(_ctx.current)), 1),
                        _createElementVNode("div", _hoisted_15, [
                          _withDirectives(_createElementVNode("input", {
                            ref: "who",
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.current.title) = $event)),
                            class: "rs-who",
                            placeholder: "Title, e.g. CEO",
                            "aria-label": "Seat title"
                          }, null, 512), [
                            [_vModelText, _ctx.current.title]
                          ]),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.current.name) = $event)),
                            class: "rs-who-name",
                            placeholder: "Name (optional), e.g. John",
                            "aria-label": "Name of who's in this seat"
                          }, null, 512), [
                            [_vModelText, _ctx.current.name]
                          ])
                        ]),
                        _createElementVNode("span", _hoisted_16, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "rs-icon",
                            "aria-label": "Move seat left",
                            disabled: _ctx.selected == 0,
                            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.moveSeat(_ctx.selected, -1)))
                          }, [...(_cache[40] || (_cache[40] = [
                            _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
                              _createElementVNode("path", { d: "M19 12H5M11 18l-6-6 6-6" })
                            ], -1)
                          ]))], 8, _hoisted_17),
                          _createElementVNode("button", {
                            type: "button",
                            class: "rs-icon",
                            "aria-label": "Move seat right",
                            disabled: _ctx.selected == _ctx.seats.length - 1,
                            onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.moveSeat(_ctx.selected, 1)))
                          }, [...(_cache[41] || (_cache[41] = [
                            _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
                              _createElementVNode("path", { d: "M5 12h14M13 18l6-6-6-6" })
                            ], -1)
                          ]))], 8, _hoisted_18),
                          _createElementVNode("button", {
                            type: "button",
                            class: "ep-chip",
                            onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.duplicateSeat(_ctx.selected)))
                          }, [...(_cache[42] || (_cache[42] = [
                            _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
                              _createElementVNode("path", { d: "M9 9h10a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H11a2 2 0 0 1-2-2V9zM5 15H4a1 1 0 0 1-1-1V5a2 2 0 0 1 2-2h9a1 1 0 0 1 1 1v1" })
                            ], -1),
                            _createTextVNode("Duplicate", -1)
                          ]))]),
                          _createElementVNode("button", {
                            type: "button",
                            class: "ep-chip",
                            onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.openPaste()))
                          }, [...(_cache[43] || (_cache[43] = [
                            _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
                              _createElementVNode("path", { d: "M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2M9 3h6v4H9zM9 12h6M9 16h4" })
                            ], -1),
                            _createTextVNode("Paste text", -1)
                          ]))]),
                          _createElementVNode("button", {
                            type: "button",
                            class: "rs-icon del",
                            "aria-label": "Remove seat",
                            onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.confirmRemoveSeat(_ctx.selected)))
                          }, [...(_cache[44] || (_cache[44] = [
                            _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
                              _createElementVNode("path", { d: "M4 7h16M10 11v6M14 11v6M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2l1-12M9 7V4h6v3" })
                            ], -1)
                          ]))])
                        ])
                      ]),
                      _createElementVNode("p", _hoisted_19, [
                        _cache[45] || (_cache[45] = _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
                          _createElementVNode("circle", {
                            cx: "12",
                            cy: "12",
                            r: "9"
                          }),
                          _createElementVNode("path", { d: "M12 8h.01M11 12h1v4h1" })
                        ], -1)),
                        _createTextVNode(" Sections are shared by every seat. Renaming, moving or removing one changes it for all " + _toDisplayString(_ctx.seats.length) + " seat" + _toDisplayString(_ctx.seats.length == 1 ? '' : 's') + ". ", 1)
                      ]),
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("span", _hoisted_22, [
                            _cache[46] || (_cache[46] = _createTextVNode("Accountabilities", -1)),
                            (_ctx.current.accountabilities.length)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_23, " (" + _toDisplayString(_ctx.current.accountabilities.length) + ")", 1))
                              : _createCommentVNode("", true)
                          ]),
                          _cache[47] || (_cache[47] = _createElementVNode("span", { class: "rs-acc-hint" }, "Also shown on the accountability chart and employee page", -1))
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.current.accountabilities, (acc, k) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: k,
                            class: "rs-acc-row"
                          }, [
                            _createElementVNode("span", _hoisted_24, _toDisplayString(k + 1), 1),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": ($event: any) => ((acc.value) = $event),
                              class: "rs-acc-v",
                              placeholder: "Accountability"
                            }, null, 8, _hoisted_25), [
                              [_vModelText, acc.value]
                            ]),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": ($event: any) => ((acc.value2) = $event),
                              class: "rs-acc-d",
                              placeholder: "Description (optional)"
                            }, null, 8, _hoisted_26), [
                              [_vModelText, acc.value2]
                            ]),
                            _createElementVNode("span", _hoisted_27, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "rs-icon",
                                "aria-label": "Move up",
                                disabled: k == 0,
                                onClick: ($event: any) => (_ctx.moveIn(_ctx.current.accountabilities, k, -1))
                              }, [...(_cache[48] || (_cache[48] = [
                                _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
                                  _createElementVNode("path", { d: "M6 15l6-6 6 6" })
                                ], -1)
                              ]))], 8, _hoisted_28),
                              _createElementVNode("button", {
                                type: "button",
                                class: "rs-icon",
                                "aria-label": "Move down",
                                disabled: k == _ctx.current.accountabilities.length - 1,
                                onClick: ($event: any) => (_ctx.moveIn(_ctx.current.accountabilities, k, 1))
                              }, [...(_cache[49] || (_cache[49] = [
                                _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
                                  _createElementVNode("path", { d: "M6 9l6 6 6-6" })
                                ], -1)
                              ]))], 8, _hoisted_29),
                              _createElementVNode("button", {
                                type: "button",
                                class: "rs-icon del",
                                "aria-label": "Remove accountability",
                                onClick: ($event: any) => (_ctx.current.accountabilities.splice(k, 1))
                              }, [...(_cache[50] || (_cache[50] = [
                                _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
                                  _createElementVNode("path", { d: "M6 6l12 12M18 6L6 18" })
                                ], -1)
                              ]))], 8, _hoisted_30)
                            ])
                          ]))
                        }), 128)),
                        _createElementVNode("button", {
                          type: "button",
                          class: "ep-chip rs-acc-add",
                          onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.addAccountability()))
                        }, [...(_cache[51] || (_cache[51] = [
                          _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
                            _createElementVNode("path", { d: "M12 5v14M5 12h14" })
                          ], -1),
                          _createTextVNode("Add accountability", -1)
                        ]))])
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sections, (section, j) => {
                        return (_openBlock(), _createElementBlock("section", {
                          key: section.id,
                          class: "rs-sec"
                        }, [
                          _createElementVNode("div", _hoisted_31, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": ($event: any) => ((section.label) = $event),
                              class: "rs-sec-l",
                              placeholder: "Section name",
                              "aria-label": "Section name",
                              title: "Renames this section on every seat"
                            }, null, 8, _hoisted_32), [
                              [_vModelText, section.label]
                            ]),
                            _createElementVNode("span", _hoisted_33, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "rs-icon",
                                "aria-label": "Move section up",
                                disabled: j == 0,
                                onClick: ($event: any) => (_ctx.moveIn(_ctx.sections, j, -1))
                              }, [...(_cache[52] || (_cache[52] = [
                                _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
                                  _createElementVNode("path", { d: "M6 15l6-6 6 6" })
                                ], -1)
                              ]))], 8, _hoisted_34),
                              _createElementVNode("button", {
                                type: "button",
                                class: "rs-icon",
                                "aria-label": "Move section down",
                                disabled: j == _ctx.sections.length - 1,
                                onClick: ($event: any) => (_ctx.moveIn(_ctx.sections, j, 1))
                              }, [...(_cache[53] || (_cache[53] = [
                                _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
                                  _createElementVNode("path", { d: "M6 9l6 6 6-6" })
                                ], -1)
                              ]))], 8, _hoisted_35),
                              _createElementVNode("button", {
                                type: "button",
                                class: "rs-icon del",
                                "aria-label": "Remove section from every seat",
                                onClick: ($event: any) => (_ctx.confirmRemoveSection(j))
                              }, [...(_cache[54] || (_cache[54] = [
                                _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
                                  _createElementVNode("path", { d: "M4 7h16M10 11v6M14 11v6M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2l1-12M9 7V4h6v3" })
                                ], -1)
                              ]))], 8, _hoisted_36)
                            ])
                          ]),
                          (section.hint)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_37, _toDisplayString(section.hint), 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_38, [
                            (_openBlock(), _createBlock(_component_tip_tap, {
                              key: _ctx.current.id + section.id,
                              "model-value": _ctx.current.values[section.id] || '',
                              "hide-toolbar": true,
                              "hide-h3": true,
                              "hide-h4": true,
                              "hide-table": true,
                              "show-align": true,
                              "onUpdate:modelValue": ($event: any) => (_ctx.setValue(section.id, $event)),
                              onFocus: ($event: any) => (_ctx.onEditorFocus($event, section))
                            }, null, 8, ["model-value", "onUpdate:modelValue", "onFocus"]))
                          ])
                        ]))
                      }), 128)),
                      _createElementVNode("button", {
                        type: "button",
                        class: "ep-addlast",
                        onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.addSection()))
                      }, [...(_cache[55] || (_cache[55] = [
                        _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
                          _createElementVNode("path", { d: "M12 5v14M5 12h14" })
                        ], -1),
                        _createTextVNode("Add section to every seat ", -1)
                      ]))])
                    ]))
                  : (_openBlock(), _createElementBlock("p", _hoisted_39, "No seats yet. Add one to get started."))
              ])
            ]),
            _createElementVNode("aside", {
              class: "ep-side",
              "aria-label": "Outline",
              style: _normalizeStyle({ top: _ctx.barHeight + 'px' })
            }, [
              _cache[57] || (_cache[57] = _createElementVNode("div", { class: "ep-side-h" }, "Seats", -1)),
              _createVNode(_component_draggable, {
                list: _ctx.sheet.seats,
                onStart: _ctx.dragStart,
                onEnd: _ctx.dragEnd,
                animation: 150,
                "ghost-class": "kanban-ghost"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.seats, (seat, i) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: seat.id,
                      type: "button",
                      class: _normalizeClass(['ep-ol', { on: _ctx.selected == i }]),
                      onClick: ($event: any) => (_ctx.select(i))
                    }, [
                      _createElementVNode("span", null, _toDisplayString(i + 1), 1),
                      _createTextVNode(_toDisplayString(_ctx.seatLabel(seat) || 'New seat'), 1)
                    ], 10, _hoisted_40))
                  }), 128))
                ]),
                _: 1
              }, 8, ["list", "onStart", "onEnd"]),
              _createVNode(_component_editor_activity, {
                comments: _ctx.comments,
                "signed-count": _ctx.signedCount,
                "required-count": _ctx.requiredSigners.length,
                version: _ctx.node.Version
              }, null, 8, ["comments", "signed-count", "required-count", "version"])
            ], 4)
          ], 512), [
            [_vShow, !_ctx.showPreview]
          ])
        ], 2),
        (_ctx.showPaste)
          ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("h3", null, "Paste text into " + _toDisplayString(_ctx.seatLabel(_ctx.current) || 'this seat'), 1),
                _cache[58] || (_cache[58] = _createElementVNode("p", null, "Paste a role description. A line that matches a section name, like \"Key Responsibilities\", starts that section, and the lines under it become its bullet points. Other headings that end with \":\" become new sections, and lines under an \"Accountabilities\" heading become accountabilities.", -1)),
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.pasteText) = $event)),
                  rows: "10",
                  placeholder: "Your Main Purpose:\nKeep the whole company pointed in the right direction.\nKey Responsibilities:\n- Set annual and quarterly Rocks",
                  "aria-label": "Text to paste"
                }, null, 512), [
                  [_vModelText, _ctx.pasteText]
                ]),
                _createElementVNode("p", _hoisted_43, _toDisplayString(_ctx.pasteSummary), 1),
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn-light",
                    onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.showPaste = false))
                  }, "Cancel"),
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass(_ctx.pasteResult.count ? 'btn' : 'btn disable-button'),
                    onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.applyPaste()))
                  }, "Paste", 2)
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.confirmAction)
          ? (_openBlock(), _createBlock(_component_confirm_delete, {
              key: 1,
              msg: _ctx.confirmMsg,
              onConfirm: _cache[21] || (_cache[21] = ($event: any) => (_ctx.runConfirm())),
              onCancel: _cache[22] || (_cache[22] = ($event: any) => (_ctx.confirmAction = null))
            }, null, 8, ["msg"]))
          : _createCommentVNode("", true),
        (_ctx.showDetails)
          ? (_openBlock(), _createBlock(_component_editor_details_drawer, {
              key: 2,
              name: _ctx.node.Name,
              "onUpdate:name": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.node.Name) = $event)),
              ownerIds: _ctx.ownerIDs,
              "onUpdate:ownerIds": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.ownerIDs) = $event)),
              locs: _ctx.locs,
              "onUpdate:locs": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.locs) = $event)),
              deps: _ctx.deps,
              "onUpdate:deps": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.deps) = $event)),
              types: _ctx.types,
              "onUpdate:types": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.types) = $event)),
              "type-label": "role sheet",
              onClose: _cache[28] || (_cache[28] = ($event: any) => (_ctx.showDetails = false))
            }, null, 8, ["name", "ownerIds", "locs", "deps", "types"]))
          : _createCommentVNode("", true),
        (_ctx.showSave)
          ? (_openBlock(), _createBlock(_component_editor_save_dialog, {
              key: 3,
              status: _ctx.node.NeedsApprovalType,
              "onUpdate:status": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.node.NeedsApprovalType) = $event)),
              version: _ctx.node.Version,
              "required-count": _ctx.requiredSigners.length,
              "signed-count": _ctx.signedCount,
              busy: _ctx.disableButton,
              "note-placeholder": "e.g. Added the Recurring Meetings section",
              onCancel: _cache[30] || (_cache[30] = ($event: any) => (_ctx.showSave = false)),
              onSave: _cache[31] || (_cache[31] = ($event: any) => (_ctx.submitCheck($event)))
            }, null, 8, ["status", "version", "required-count", "signed-count", "busy"]))
          : _createCommentVNode("", true),
        (_ctx.showDiscard)
          ? (_openBlock(), _createBlock(_component_editor_discard_dialog, {
              key: 4,
              onKeep: _cache[32] || (_cache[32] = ($event: any) => (_ctx.showDiscard = false)),
              onDiscard: _cache[33] || (_cache[33] = ($event: any) => (_ctx.leave()))
            }))
          : _createCommentVNode("", true),
        (_ctx.showAIModal)
          ? (_openBlock(), _createBlock(_component_ai_improve_panel, {
              key: 5,
              "node-type": "sheet",
              slug: _ctx.node.Slug,
              "current-draft": { name: _ctx.node.Name, sheet: _ctx.sheet },
              onClose: _cache[34] || (_cache[34] = ($event: any) => (_ctx.showAIModal = false)),
              onApply: _cache[35] || (_cache[35] = d => { _ctx.onAIDraft(d); _ctx.showAIModal = true }),
              onAccept: _ctx.onAIDraft
            }, null, 8, ["slug", "current-draft", "onAccept"]))
          : _createCommentVNode("", true),
        (_ctx.showAIConfirm)
          ? (_openBlock(), _createBlock(_component_confirm_delete, {
              key: 6,
              onConfirm: _cache[36] || (_cache[36] = ($event: any) => (_ctx.submit())),
              onCancel: _cache[37] || (_cache[37] = () => { _ctx.showAIConfirm = false; }),
              msg: _ctx.AIConfirmText
            }, null, 8, ["msg"]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}